import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import ConversationsTab from "./ConversationsTab";
import IncomingMessagesTab from "./IncomingMessagesTab";
import OutgoingMessagesTab from "./OutgoingMessagesTab";
import FirstResponseTimeTab from "./FirstResponseTimeTab";
import ResolutionTimeTab from "./ResolutionTimeTab";
import ResolutionCountTab from "./ResolutionCountTab";

const Wrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;
const TabTables = ({ overviewReportdata }) => {
  const [key, setKey] = React.useState("Conversations");
  return (
    <>
      <div className="chatinput-section">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          {/* Conversations Tab */}
          <Tab
            eventKey="Conversations"
            title={
              !!overviewReportdata &&
              !!overviewReportdata.total_coversationCount
                ? `Conversations (${overviewReportdata.total_coversationCount})`
                : `Conversations (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ConversationsTab overviewReportdata={overviewReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/* Incoming Messages Tab */}
          <Tab
            eventKey="Incoming"
            title={
              !!overviewReportdata &&
              !!overviewReportdata.total_incommngMsgCount
                ? `Incoming Messages (${overviewReportdata.total_incommngMsgCount})`
                : `Incoming Messages (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <IncomingMessagesTab
                    overviewReportdata={overviewReportdata}
                  />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/* Outgoing Messages Tab */}
          <Tab
            eventKey="Outgoing"
            title={
              !!overviewReportdata &&
              !!overviewReportdata.total_outgoingMsgCount
                ? `Outgoing Messages (${overviewReportdata.total_outgoingMsgCount})`
                : `Outgoing Messages (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <OutgoingMessagesTab
                    overviewReportdata={overviewReportdata}
                  />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*First response time Messages Tab */}
          <Tab
            eventKey="FirstrResponseTime"
            title={
              !!overviewReportdata &&
              !!overviewReportdata.total_firstResponceTimeCount
                ? `First response time (${overviewReportdata.total_firstResponceTimeCount})`
                : `First response time (00:00:00)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <FirstResponseTimeTab
                    overviewReportdata={overviewReportdata}
                  />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*Resolution Time Messages Tab */}
          <Tab
            eventKey="ResolutionTime"
            title={
              !!overviewReportdata &&
              !!overviewReportdata.total_resolutionTimeCount
                ? `Resolution Time (${overviewReportdata.total_resolutionTimeCount})`
                : `Resolution Time (00:00:00)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ResolutionTimeTab overviewReportdata={overviewReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*Resolution Count Messages Tab */}
          <Tab
            eventKey="ResolutionCount"
            title={
              !!overviewReportdata && !!overviewReportdata.total_resolutionCount
                ? `Resolution Count (${overviewReportdata.total_resolutionCount})`
                : `Resolution Count (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ResolutionCountTab overviewReportdata={overviewReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default TabTables;
